import { Z_INDEX_NAV_COMPONENT_DEFAULT } from '../../../constants/z_index';
export const getStyle = () => {
  return {
    height: `100vh`,
    width: '610px',
    position: 'fixed',
    top: 0,
    right: 0,
    zIndex: Z_INDEX_NAV_COMPONENT_DEFAULT
  };
};